import { allowCookieConsent } from '../../actions/cookies/cookieConsent';

export const setCookieConsent = (allowCookies) => dispatch => {
  return dispatch(allowCookieConsent(allowCookies));
};
